import "./ProjectInventoryChartKey.css";

import { ColorConstants } from "../../../../../../../constants";

interface ProjectInventoryChartKeyProps {
  unitMeasurement: string;
}

export const ProjectInventoryChartKey = ({ unitMeasurement }: ProjectInventoryChartKeyProps): JSX.Element => {
  return (
    <div className="ProjectInventoryChartKey">
      <h3>{unitMeasurement !== "Biodiversity" ? "Verified" : "Units"}</h3>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_200 }} />
        <p>Available</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_400 }} />
        <p>Reserved</p>
      </div>
      <div className="KeyItem">
        <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.GREEN_600 }} />
        <p>Sold</p>
      </div>
      {unitMeasurement !== "Biodiversity" && (
        <>
          <div className="KeyBreak" />
          <h3>Pending</h3>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_100 }} />
            <p>Available</p>
          </div>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_300 }} />
            <p>Reserved</p>
          </div>
          <div className="KeyItem">
            <div className="KeyItemColour" style={{ backgroundColor: ColorConstants.INDIGO_500 }} />
            <p>Sold</p>
          </div>
        </>
      )}
    </div>
  );
};
